import React, { CSSProperties, useMemo } from 'react';
import { Progress, ProgressProps } from 'reactstrap';
import { Property as P } from 'csstype';
import Color from 'color';
import { Theme } from '../themes';
import styled, { useTheme } from '../themes/themed-styled-components';

type FancyProgressProps = Omit<ProgressProps, 'barStyle'>;

const barColor = (val: number, theme: Theme): P.Color => {
    if (val <= 0) {
        return theme.danger;
    }

    if (val < .334) {
        return Color(theme.danger).mix(Color(theme.warning), val * 2).hex();
    }

    if (val === 0.334) {
        return theme.warning;
    }

    if (val < .667) {
        return Color(theme.warning).mix(Color(theme.success), (val - .5) * 2).hex();
    }

    if (val === .667) {
        return theme.warning;
    }

    if (val < .1) {
        return Color(theme.success).mix(Color(theme.primary), (val - .5) * 2).hex();
    }

    return theme.primary;
}

const ProgressContentWrapper = styled.span`
    padding: 0 ${({ theme }) => theme.spacers[2]};
    background-color: rgba(0,0,0,.25)
`;

const FancyProgress = ({ children, min, max, value, ...props }: FancyProgressProps) => {
    const theme = useTheme() as Theme;

    const barStyle = useMemo<CSSProperties>(() => {

        if (min === undefined || max === undefined || value === undefined) {
            return {};
        }

        var backgroundColor = barColor((value - min) / (max - min), theme);

        return {
            backgroundColor,
            transition: 'width 0.5s, background-color 0.5s',
            overflow: 'visible'
        };
    }, [min, max, value, theme]);


    return <Progress barStyle={barStyle} min={min} max={max} value={value} {...props}><ProgressContentWrapper>{children}</ProgressContentWrapper></Progress>;
};

export default FancyProgress;
